import * as jQuery from "jquery";
import debounce from "lodash-es/debounce";
import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import { fromOthersNodeName } from "motw_core/Repositories/WorkflowRepository";
import * as React from "react";
import { IBookOfMindState } from "source/app/presentation/MainPanel/Workflows/BookOfMind/Helpers/IBookOfMindState";
import { Style } from "source/app/presentation/Shared/Styles/CSS";
import { Sounds } from "source/app/services/Sound/Sounds";
import { ReadState } from "source/app/services/UI/State/ReadState";
import { SetState } from "source/app/services/UI/State/SetState";
import { SetBookOfMindState } from "../Helpers/BookOfMindHelpers";
import { BookOfMindToolAction } from "./BookOfMindToolAction";
import { DisplayOrderPicker } from "./DisplayOrderPicker";
import { ExportLink } from "./ExportLink";
import { ShowAllQuotes } from "./ShowAllQuotes";
import { UpdateFilteredQuotes } from "./UpdateFilteredQuotes";

export const BookOfMindTools = ({
    rootNodeName,
    state,
}: {
    rootNodeName: string;
    state: IBookOfMindState;
}) => (
    <div
        id="tools"
        {...Style(`bookOfMindOptionsTools`, {
            margin: `0px`,
            position: `relative`,
            top: `-2px`,
            fontSize: `14px`,
            fontFamily: `Montaga`,
            fontStyle: `normal`,
            marginTop: `10px`,
            padding: `11px 0px 0px`,
            borderTop: `1px solid rgba(173, 139, 62, 0.2)`,
            color: `#bdbdbd`,
            textAlign: `center`,
            display: "grid",
            gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
            gap: "0.35rem",
        })}
    >
        <BookOfMindToolAction>
            <ShowAllQuotes rootNodeName={rootNodeName} />
        </BookOfMindToolAction>
        <BookOfMindToolAction>
            <DisplayOrderPicker state={state} />
        </BookOfMindToolAction>
        <BookOfMindToolAction>
            <ExportLink />
        </BookOfMindToolAction>
    </div>
);

export const UpdateFilteredQuotesDebounced = debounce(
    UpdateFilteredQuotes,
    400
);

export const RefreshBookOfMindQuotes = () => {
    Sounds.paper_long_flip.Play();

    SetBookOfMindState({ refreshTimeStamp: Date.now() });

    // ScrollToDiv didn't work here
    jQuery(`#childContainer`).scrollTop(0);
};

export const SelectNextBookOfMindQuotesBatch = () => {
    Sounds.paper_long_flip.Play();

    const bookOfMindState = ReadState<IBookOfMindState>(
        ESharedFunction.BookOfMind
    );

    if (!bookOfMindState) {
        return;
    }

    const currentQuotesToDisplay = bookOfMindState.remainingQuotesToDisplay;

    const newQuotesToDisplay = currentQuotesToDisplay.slice(
        bookOfMindState.numberOfQuotesToDisplay
    );

    SetBookOfMindState({ remainingQuotesToDisplay: newQuotesToDisplay });

    // ScrollToDiv didn't work here
    jQuery(`#childContainer`).scrollTop(0);
};

export const ClearSearch = () => {
    SetState(ESharedFunction.BookOfMindSearch_searchText, "");
    UpdateFilteredQuotesDebounced("");
};
